import React from 'react';
import classNames from 'classnames';
import './MCIcon.scss'

/**
 * Ikona z Marbes ikonfontu.
 */
export default class Icon extends React.Component {
    baseClassName = 'icon';

    static animation = {
        pulse: 'pulse', spin: 'spin'
    };

    static animationList = ['pulse', 'spin'];

    static pull = {
        left: 'left', right: 'right'
    };

    static pullList = ['left', 'right'];

    static rotate = {
        A_90: '90',
        A_180: '180',
        A_270: '270',
        horizontal: 'horizontal',
        vertical: 'vertical'
    };

    static rotateList = [
        '90',
        '180',
        '270',
        'horizontal',
        'vertical'
    ];

    static size = {
        LG: 'lg',
        X2: '2x',
        X3: '3x',
        X4: '4x',
        X5: '5x'
    };

    static sizeList = [
        'lg',
        '2x',
        '3x',
        '4x',
        '5x'
    ];

    static color = {
        primary: 'primary',
        success: 'success',
        warning: 'warning',
        danger: 'danger',
        info: 'info',
    };

    static PropTypes = {
        animation: React.PropTypes.oneOf(Icon.animationList),
        border: React.PropTypes.bool,
        className: React.PropTypes.string,
        fixedWidth: React.PropTypes.bool,
        icon: React.PropTypes.string.isRequired,
        pull: React.PropTypes.oneOf(Icon.pullList),
        rotate: React.PropTypes.oneOf(Icon.rotateList),
        size: React.PropTypes.oneOf(Icon.sizeList),
        color: React.PropTypes.oneOf(Object.keys(Icon.color)),
    };

    static defaultProps = {
        border: false,
        fixedWidth: false
    };

    render() {
        let {
            animation,
            spinner,
            border,
            className,
            fixedWidth,
            icon,
            pull,
            rotate,
            size,
            color,
            ...otherProps
        } = this.props;

        const baseClassNames = [this.baseClassName];
        if (this.baseClassName !== "icon") {
            baseClassNames.push("icon");
        }

        className = classNames(
            [...baseClassNames, `${this.baseClassName}-${icon}`],
            animation ? `${this.baseClassName}-${animation}` : '',
            {
                [this.baseClassName + '-border']: border,
                [this.baseClassName + '-fw']: fixedWidth,
                [this.baseClassName + '-pull-left']: pull === Icon.pull.left,
                [this.baseClassName + '-pull-right']: pull === Icon.pull.right,
                [this.baseClassName + '-rotate-90']: rotate === Icon.rotate.A_90,
                [this.baseClassName + '-rotate-180']: rotate === Icon.rotate.A_180,
                [this.baseClassName + '-rotate-270']: rotate === Icon.rotate.A_270,
                [this.baseClassName + '-rotate-horizontal']: rotate === Icon.rotate.horizontal,
                [this.baseClassName + '-rotate-vertical']: rotate === Icon.rotate.vertical,
                [this.baseClassName + '-lg']: size === Icon.size.LG,
                [this.baseClassName + '-2x']: size === Icon.size.X2,
                [this.baseClassName + '-3x']: size === Icon.size.X3,
                [this.baseClassName + '-4x']: size === Icon.size.X4,
                [this.baseClassName + '-5x']: size === Icon.size.X5,
                ['text-' + color]: color != null,
            },
            className
        );

        return (
            <i className={className} {...otherProps}></i>
        );
    }
}
